export default function PageHeader({ eyebrow, title, description, right }) {
  return (
    <div className="border-b border-tactical-border bg-tactical-surface/50 backdrop-blur px-4 md:px-8 lg:px-12 py-6 md:py-8">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          {eyebrow && (
            <div className="font-mono text-[10px] md:text-xs text-volt tracking-[0.25em] uppercase mb-2">{eyebrow}</div>
          )}
          <h1 className="font-display font-black text-3xl md:text-4xl lg:text-5xl tracking-tight leading-none">{title}</h1>
          {description && <p className="text-white/50 mt-2 max-w-2xl text-sm md:text-base">{description}</p>}
        </div>
        {right}
      </div>
    </div>
  );
}
